import { withAlpha } from "@nexus/widget-sdk";
import type { ChartColors } from "@nexus/widget-sdk";
import type { PirateSourceType } from "./types";

/** Canonical source order: the donut's slice order and the summary's tie-break. */
export const SOURCE_ORDER: PirateSourceType[] = ["ott", "sat", "others", "unknown"];

/**
 * One colour per source, shared by the donut and the summary so a source is
 * the same colour in both: an index into the categorical `--chart-*` series
 * and the fill opacity the donut has always used.
 */
const SOURCE_SERIES_INDEX: Record<PirateSourceType, number> = {
  ott: 0,
  sat: 2,
  others: 1,
  unknown: 4,
};
const SOURCE_FILL_ALPHA = 0.78;

/** The donut's slice colours, in `SOURCE_ORDER`. */
export function sourceSliceColors(series: ChartColors["series"]): string[] {
  return SOURCE_ORDER.map((source) =>
    withAlpha(series[SOURCE_SERIES_INDEX[source]], SOURCE_FILL_ALPHA),
  );
}

/** The same colour as a CSS value, for the summary (`--chart-N` is 1-based). */
export function sourceCssColor(source: PirateSourceType): string {
  return `color-mix(in srgb, var(--chart-${SOURCE_SERIES_INDEX[source] + 1}) ${SOURCE_FILL_ALPHA * 100}%, transparent)`;
}
